import State from '../core/State';
import { VisitorData } from '@kaizenplatform/intelligence-entity';
import initialState from '../initialState';
import produce, { Draft } from 'immer';

export const startFetchingVisitorsByPv = () =>
  produce((draft: Draft<State>) => {
    draft.visitorsByPv.fetching = draft.visitorsByPv.fetching + 1;
  });

export const setVisitorsByPv = (visitorData: VisitorData) =>
  produce((draft: Draft<State>) => {
    draft.visitorsByPv.data = visitorData;
  });

export const finishFetchingVisitorsByPv = () =>
  produce((draft: Draft<State>) => {
    draft.visitorsByPv.fetching = draft.visitorsByPv.fetching - 1;
  });

export const disposeVisitorsByPv = () =>
  produce((draft: Draft<State>) => {
    draft.visitorsByPv.data = initialState.visitorsByPv.data;
    draft.visitorsByPv.fetching = initialState.visitorsByPv.fetching;
  });
